import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import KEY_CODES from 'commons-forms/constants/keycodes.js';
import 'commons-forms/components/InputNumber/InputNumber.scss';

class InputNumber extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.incrementValue = this.incrementValue.bind(this);
        this.decrementValue = this.decrementValue.bind(this);
        this.getStepToRoundedValue = this.getStepToRoundedValue.bind(this);

        this.updateParent = _.debounce(props.onChange, 300);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.value) {
            this.setState({
                value: nextProps.value,
            });
        }
    }

    onChange(event) {
        const { value } = event.target;
        this.setState({ value });
    }

    onBlur() {
        let value = this.state.value.toString().replace(/,/g, '.');
        value = this.clamp(parseFloat(value));
        if (_.isNaN(value)) {
            value = 0;
        }
        this.setState({ value });
        this.updateParent(value);
    }

    onKeyUp(event) {
        const pressedKeyCode = event.which;

        if ([KEY_CODES.UP, KEY_CODES.DOWN].includes(pressedKeyCode)) {
            event.preventDefault();
            if (pressedKeyCode === KEY_CODES.UP) {
                this.incrementValue();
            } else {
                this.decrementValue();
            }
        }
    }

    getStepToRoundedValue(isIncrement) {
        let stepToRoundedValue = this.props.step;

        const isRounded = this.state.value % 1 === 0;
        if (!isRounded) {
            stepToRoundedValue = this.state.value % this.props.step;
            if (isIncrement) {
                stepToRoundedValue = this.props.step - stepToRoundedValue;
            }
        }
        return stepToRoundedValue;
    }

    clamp(value) {
        return _.clamp(value, this.props.min, this.props.max);
    }

    incrementValue() {
        const stepToRoundedValue = this.getStepToRoundedValue(true);
        this.adjustCurrentValue(stepToRoundedValue);
    }

    decrementValue() {
        const stepToRoundedValue = this.getStepToRoundedValue(false);
        this.adjustCurrentValue(-stepToRoundedValue);
    }

    adjustCurrentValue(delta) {
        let value = (parseFloat(this.state.value) + delta).toFixed(this.props.decimalCount);
        value = this.clamp(value).toString();
        this.setState({ value }, () => this.updateParent(value));
    }

    render() {
        const wrapperClass = ['InputNumber'];
        const btnAddClass = ['InputNumber--add'];
        const btnMinusClass = ['InputNumber--minus'];
        if (this.props.showLabel) {
            wrapperClass.push('labeled');
        }
        if (this.state.value === this.props.max.toFixed(2)) {
            btnAddClass.push('disabled-btn');
        }
        if (this.state.value === this.props.min.toFixed(2)) {
            btnMinusClass.push('disabled-btn');
        }
        if (this.props.lightTheme) {
            wrapperClass.push('light-theme');
        }
        return (
            <div className={wrapperClass.join(' ')}>
                <button className={btnMinusClass.join(' ')} onClick={this.decrementValue}>
                    <icon className="icon-minus" />
                </button>
                {this.props.showLabel && <div className="InputNumber--label">{this.props.label}</div>}
                <input
                    type="text"
                    onChange={this.onChange}
                    value={this.state.value}
                    onBlur={this.onBlur}
                    onKeyUp={this.onKeyUp}
                />
                <button className={btnAddClass.join(' ')} onClick={this.incrementValue}>
                    <icon className="icon-plus" />
                </button>
            </div>
        );
    }
}

InputNumber.defaultProps = {
    step: 1,
    value: '0',
    min: Number.MIN_VALUE,
    max: Number.MAX_VALUE,
    decimalCount: 0,
    showLabel: true,
    lightTheme: false,
};

InputNumber.propTypes = {
    step: PropTypes.number,
    value: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    decimalCount: PropTypes.number,
    label: PropTypes.string,
    showLabel: PropTypes.bool,
    lightTheme: PropTypes.bool,
};

export default InputNumber;
